import BaseDesignDataService from '@configuratorware/configurator-frontendgui/App/Services/DesignDataService';

export default class DesignDataService extends BaseDesignDataService {
  updateVisualization(visualization) {}
}
